var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "Country", "data-page": "country" } },
    [
      _c(
        "div",
        {
          class: _vm.citationModalDisplayed ? "displayed" : "",
          attrs: { id: "CiteModalWrapper" }
        },
        [
          _c("div", {
            attrs: { id: "CiteModalBg" },
            on: {
              click: function($event) {
                return _vm.closeCitationModal()
              }
            }
          }),
          _c("div", { attrs: { id: "CiteModal" } }, [
            _c("div", {
              staticClass: "modal_closebt",
              on: {
                click: function($event) {
                  return _vm.closeCitationModal()
                }
              }
            }),
            _c("div", { staticClass: "modal_title" }, [
              _vm._v("How to cite ?")
            ]),
            _c("div", {
              staticClass: "modal_text",
              domProps: { innerHTML: _vm._s(_vm.citationModalText) }
            }),
            _c("div", { staticClass: "modal_buttons" }, [
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "text" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("text")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy text")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "apa" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("apa")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy APA")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "bip" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("bip")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [
                    _vm._v("Copy BipTex")
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: {
          bgColor: "blue",
          page: "country",
          stickyTitle: _vm.countryObj.country_name
        },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          {
            staticClass: "main_loader loader lds-ellipsis",
            class: _vm.mainLoaderDisplayed ? "displayed" : ""
          },
          [_c("div"), _c("div"), _c("div"), _c("div")]
        ),
        _c(
          "div",
          {
            staticClass: "main_inner",
            class: _vm.mainLoaderDisplayed ? "opacified" : ""
          },
          [
            _c("section", { staticClass: "main_section" }, [
              _c(
                "div",
                {
                  staticClass: "section_content",
                  attrs: { id: "CountryInfos" }
                },
                [
                  _c("h2", { staticClass: "text_subtitle" }, [
                    _vm._v("Countries")
                  ]),
                  _c("h1", { staticClass: "title_page text_title2" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.countryObj.country_name) +
                        "\n                    "
                    )
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "app_button2",
                      staticStyle: { "margin-top": "20px" },
                      on: {
                        click: function($event) {
                          return _vm.openModal("country")
                        }
                      }
                    },
                    [_vm._v("Change country")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "text_p",
                      staticStyle: { "margin-top": "14px" }
                    },
                    [
                      _vm._v(
                        "\n                        Scroll down to view country-specific data for each of the four topics covered by the Atlas.\n                    "
                      )
                    ]
                  )
                ]
              )
            ]),
            _c(
              "section",
              {
                staticClass: "main_section section_chart",
                attrs: { id: "Wrapper_profit", "data-dataset": "global-profit" }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm.isTaxHavenGlobalProfit
                    ? _c("div", { staticClass: "title_taxhaven" }, [
                        _vm._v(
                          _vm._s(_vm.countryObj.country_name) +
                            " is classified as a tax haven"
                        )
                      ])
                    : _vm._e(),
                  _vm.DBDatasetsTexts["global-profit"] != undefined
                    ? _c("div", { staticClass: "content_title" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.DBDatasetsTexts["global-profit"].title) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm.globalProfitHasData
                    ? _c("div", { staticClass: "section_hr" }, [
                        _c("div", { staticClass: "hr_text dataset" }, [
                          _vm._v("Indicator Filters")
                        ])
                      ])
                    : _vm._e(),
                  _vm.globalProfitHasData
                    ? _c(
                        "div",
                        {
                          staticClass: "section_row row_filters",
                          attrs: { "data-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Indicator")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.globalProfitIndicators,
                                  "return-object": true,
                                  label: "Choose an indicator",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateSelectboxItem(
                                                        data.item.label
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619319307
                                ),
                                model: {
                                  value: _vm.selectedGlobalProfitIndicator,
                                  callback: function($$v) {
                                    _vm.selectedGlobalProfitIndicator = $$v
                                  },
                                  expression: "selectedGlobalProfitIndicator"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.globalProfitHasData
                    ? _c("div", { staticClass: "section_row" }, [
                        _c(
                          "div",
                          { staticClass: "country_wrapper" },
                          [
                            _vm.isDataLoaded &&
                            _vm.selectedGlobalProfitIndicator.id !=
                              "corp_tax_lost"
                              ? _c("div", { staticClass: "area_title" }, [
                                  _c("span", { staticClass: "title_label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.selectedGlobalProfitIndicator.label
                                      )
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title_lostwon",
                                      attrs: {
                                        "data-taxhavens": _vm.isTaxHavenGlobalProfit
                                          ? "true"
                                          : ""
                                      }
                                    },
                                    [
                                      !_vm.isTaxHavenGlobalProfit
                                        ? _c("span", [_vm._v("lost")])
                                        : _c("span", [_vm._v("won")])
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "title_label unit" },
                                    [
                                      _vm._v(
                                        " (in " +
                                          _vm._s(
                                            _vm.globalProfitIndicatorUnit
                                          ) +
                                          ")"
                                      )
                                    ]
                                  )
                                ])
                              : _vm.isDataLoaded &&
                                _vm.selectedGlobalProfitIndicator.id ==
                                  "corp_tax_lost"
                              ? _c("div", { staticClass: "area_title" }, [
                                  _c("span", { staticClass: "title_label" }, [
                                    _vm._v("Corporate tax revenue")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title_lostwon",
                                      attrs: {
                                        "data-taxhavens": _vm.isTaxHavenGlobalProfit
                                          ? "true"
                                          : ""
                                      }
                                    },
                                    [
                                      !_vm.isTaxHavenGlobalProfit
                                        ? _c("span", [_vm._v("lost")])
                                        : _c("span", [_vm._v("won")])
                                    ]
                                  ),
                                  _c("span", { staticClass: "title_label" }, [
                                    _vm._v(
                                      "as a share of corporate tax revenue collected"
                                    )
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "title_label unit" },
                                    [
                                      _vm._v(
                                        " (in " +
                                          _vm._s(
                                            _vm.globalProfitIndicatorUnit
                                          ) +
                                          ")"
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _c("highchartsAreaChart", {
                              attrs: {
                                areaChartData: _vm.globalProfitAreaSeries,
                                areaChartCategories:
                                  _vm.globalProfitAreaCategories,
                                indicatorUnit: _vm.globalProfitIndicatorUnit
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content_downloadbar" }, [
                          _c("div", { staticClass: "downloadbar_wrapper" }, [
                            _c("div", { staticClass: "downloadbar_title" }, [
                              _vm._v("Download")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportXLS("profit")
                                  }
                                }
                              },
                              [_vm._v("Dataset (.xslx)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportGraphic("profit")
                                  }
                                }
                              },
                              [_vm._v("Image (.png)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt cite",
                                on: {
                                  click: function($event) {
                                    return _vm.displayCitationModal(
                                      "global-profit"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Cite")]
                            )
                          ])
                        ]),
                        _vm.DBDatasetsTexts["global-profit"] != undefined
                          ? _c("div", { staticClass: "content_more" }, [
                              _c("div", { staticClass: "more_text" }, [
                                _vm.globalProfitTextExpanded
                                  ? _c("div", [
                                      _vm.isTaxHavenGlobalProfit
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.DBDatasetsTexts[
                                                  "global-profit"
                                                ].Country_Page_Desc_Tax
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.DBDatasetsTexts[
                                                  "global-profit"
                                                ].Country_Page_Desc_NonTax
                                              ) + " "
                                            )
                                          ])
                                    ])
                                  : _c("div", [
                                      _vm.isTaxHavenGlobalProfit
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.truncate(
                                                  _vm.DBDatasetsTexts[
                                                    "global-profit"
                                                  ].Country_Page_Desc_Tax
                                                )
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.truncate(
                                                  _vm.DBDatasetsTexts[
                                                    "global-profit"
                                                  ].Country_Page_Desc_NonTax
                                                )
                                              ) + " "
                                            )
                                          ])
                                    ])
                              ]),
                              (_vm.isTaxHavenGlobalProfit &&
                                _vm.DBDatasetsTexts["global-profit"]
                                  .Country_Page_Desc_Tax.length >
                                  _vm.datasetTextLimit) ||
                              (!_vm.isTaxHavenGlobalProfit &&
                                _vm.DBDatasetsTexts["global-profit"]
                                  .Country_Page_Desc_NonTax.length >
                                  _vm.datasetTextLimit)
                                ? _c("div", { staticClass: "more_actionbar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "actionbar_bt",
                                        on: {
                                          click: function($event) {
                                            _vm.globalProfitTextExpanded = !_vm.globalProfitTextExpanded
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.globalProfitTextExpanded
                                              ? "Collapse"
                                              : "Read More"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _c("div", { staticClass: "section_row" }, [
                        _c("div", { staticClass: "chart_nodatablock" })
                      ])
                ])
              ]
            ),
            _c(
              "section",
              {
                staticClass: "main_section section_chart",
                attrs: { "data-dataset": "offshore-financial" }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm.isTaxHavenOffshoreFinancial
                    ? _c("div", { staticClass: "title_taxhaven" }, [
                        _vm._v(
                          _vm._s(_vm.countryObj.country_name) +
                            " is classified as a financial center"
                        )
                      ])
                    : _vm._e(),
                  _vm.isDataLoaded
                    ? _c("div", { staticClass: "content_title" }, [
                        _vm.isTaxHavenOffshoreFinancial
                          ? _c("span", [
                              _vm._v(
                                "\n                            Offshore financial wealth hosted by " +
                                  _vm._s(_vm.countryObj.country_name) +
                                  "\n                        "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                            Offshore financial wealth owned by " +
                                  _vm._s(_vm.countryObj.country_name) +
                                  "\n                        "
                              )
                            ])
                      ])
                    : _vm._e(),
                  _vm.offshoreFinancialHasData
                    ? _c("div", { staticClass: "section_hr" }, [
                        _c("div", { staticClass: "hr_text" }, [
                          _vm._v("Indicator Filters")
                        ])
                      ])
                    : _vm._e(),
                  _vm.offshoreFinancialHasData
                    ? _c(
                        "div",
                        {
                          staticClass: "section_row row_filters",
                          attrs: { "data-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Indicator")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.offshoreFinancialIndicators,
                                  "return-object": true,
                                  label: "Choose an indicator",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateSelectboxItem(
                                                        data.item.label
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619319307
                                ),
                                model: {
                                  value: _vm.selectedOffshoreFinancialIndicator,
                                  callback: function($$v) {
                                    _vm.selectedOffshoreFinancialIndicator = $$v
                                  },
                                  expression:
                                    "selectedOffshoreFinancialIndicator"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.offshoreFinancialHasData
                    ? _c("div", { staticClass: "section_row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "country_wrapper",
                            attrs: { id: "Wrapper_financial" }
                          },
                          [
                            _vm.isDataLoaded
                              ? _c("div", { staticClass: "legend_title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title_indicator" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedOffshoreFinancialIndicator
                                            .subtitleLabel
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title_taxhavens",
                                      attrs: {
                                        "data-taxhavens": _vm.isTaxHavenOffshoreFinancial
                                          ? "true"
                                          : ""
                                      }
                                    },
                                    [
                                      !_vm.isTaxHavenOffshoreFinancial
                                        ? _c("span", [_vm._v("owned")])
                                        : _c("span", [_vm._v("held")])
                                    ]
                                  ),
                                  _vm.selectedOffshoreFinancialIndicator
                                    .homeUnit != undefined
                                    ? _c("div", { staticClass: "title_unit" }, [
                                        _vm._v(
                                          "(in " +
                                            _vm._s(
                                              _vm
                                                .selectedOffshoreFinancialIndicator
                                                .homeUnit
                                            ) +
                                            ")"
                                        )
                                      ])
                                    : _c("div", { staticClass: "title_unit" }, [
                                        _vm._v(
                                          "(in " +
                                            _vm._s(
                                              _vm
                                                .selectedOffshoreFinancialIndicator
                                                .unit
                                            ) +
                                            ")"
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _c("highchartsAreaChart", {
                              attrs: {
                                areaChartData: _vm.offshoreFinancialAreaSeries,
                                areaChartCategories:
                                  _vm.offshoreFinancialAreaCategories,
                                indicatorUnit: _vm.offshoreFinancialAreaUnit,
                                chartID: "AreaChartOffshore"
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content_downloadbar" }, [
                          _c("div", { staticClass: "downloadbar_wrapper" }, [
                            _c("div", { staticClass: "downloadbar_title" }, [
                              _vm._v("Download")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportXLS("financial")
                                  }
                                }
                              },
                              [_vm._v("Dataset (.xslx)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportGraphic("financial")
                                  }
                                }
                              },
                              [_vm._v("Image (.png)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt cite",
                                on: {
                                  click: function($event) {
                                    return _vm.displayCitationModal(
                                      "offshore-financial"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Cite")]
                            )
                          ])
                        ]),
                        _vm.DBDatasetsTexts["offshore-financial"] != undefined
                          ? _c("div", { staticClass: "content_more" }, [
                              _c("div", { staticClass: "more_text" }, [
                                _vm.offshoreFinancialTextExpanded
                                  ? _c("div", [
                                      _vm.isTaxHavenOffshoreFinancial
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.DBDatasetsTexts[
                                                  "offshore-financial"
                                                ].Country_Page_Desc_Tax
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.DBDatasetsTexts[
                                                  "offshore-financial"
                                                ].Country_Page_Desc_NonTax
                                              ) + " "
                                            )
                                          ])
                                    ])
                                  : _c("div", [
                                      _vm.isTaxHavenOffshoreFinancial
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.truncate(
                                                  _vm.DBDatasetsTexts[
                                                    "offshore-financial"
                                                  ].Country_Page_Desc_Tax
                                                )
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.truncate(
                                                  _vm.DBDatasetsTexts[
                                                    "offshore-financial"
                                                  ].Country_Page_Desc_NonTax
                                                )
                                              ) + " "
                                            )
                                          ])
                                    ])
                              ]),
                              (_vm.isTaxHavenOffshoreFinancial &&
                                _vm.DBDatasetsTexts["offshore-financial"]
                                  .Country_Page_Desc_Tax.length >
                                  _vm.datasetTextLimit) ||
                              (!_vm.isTaxHavenOffshoreFinancial &&
                                _vm.DBDatasetsTexts["offshore-financial"]
                                  .Country_Page_Desc_NonTax.length >
                                  _vm.datasetTextLimit)
                                ? _c("div", { staticClass: "more_actionbar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "actionbar_bt",
                                        on: {
                                          click: function($event) {
                                            _vm.offshoreFinancialTextExpanded = !_vm.offshoreFinancialTextExpanded
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offshoreFinancialTextExpanded
                                              ? "Collapse"
                                              : "Read More"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _c("div", { staticClass: "section_row" }, [
                        _c("div", { staticClass: "chart_nodatablock" })
                      ])
                ])
              ]
            ),
            _vm.isHybridOffshoreFinancial
              ? _c(
                  "section",
                  {
                    staticClass: "main_section section_chart",
                    attrs: { "data-dataset": "offshore-financial" }
                  },
                  [
                    _c("div", { staticClass: "section_content" }, [
                      _c("div", { staticClass: "title_taxhaven" }, [
                        _vm._v(
                          _vm._s(_vm.countryObj.country_name) +
                            " is classified as a financial center"
                        )
                      ]),
                      _vm.isDataLoaded
                        ? _c("div", { staticClass: "content_title" }, [
                            _c("span", [
                              _vm._v(
                                "\n                            Offshore financial wealth hosted by " +
                                  _vm._s(_vm.countryObj.country_name) +
                                  "\n                        "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm.offshoreFinancialHybridHasData
                        ? _c("div", { staticClass: "section_hr" }, [
                            _c("div", { staticClass: "hr_text" }, [
                              _vm._v("Indicator Filters")
                            ])
                          ])
                        : _vm._e(),
                      _vm.offshoreFinancialHybridHasData
                        ? _c(
                            "div",
                            {
                              staticClass: "section_row row_filters",
                              attrs: { "data-align": "left" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "content_filter" },
                                [
                                  _c("div", { staticClass: "filter_label" }, [
                                    _vm._v("Indicator")
                                  ]),
                                  _c("v-select", {
                                    staticClass:
                                      "actionblock_selectbox app_selectbox",
                                    attrs: {
                                      items:
                                        _vm.offshoreFinancialHybridIndicators,
                                      "return-object": true,
                                      label: "Choose an indicator",
                                      solo: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "item_wrapper" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item_text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.truncateSelectboxItem(
                                                            data.item.label
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "item_wrapper",
                                                  attrs: {
                                                    "data-item": data.item.id
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item_text"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass: "item_icon"
                                                      }),
                                                      _vm._v(
                                                        _vm._s(data.item.label)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      619319307
                                    ),
                                    model: {
                                      value:
                                        _vm.selectedOffshoreFinancialHybridIndicator,
                                      callback: function($$v) {
                                        _vm.selectedOffshoreFinancialHybridIndicator = $$v
                                      },
                                      expression:
                                        "selectedOffshoreFinancialHybridIndicator"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.offshoreFinancialHybridHasData
                        ? _c("div", { staticClass: "section_row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "country_wrapper",
                                attrs: { id: "Wrapper_financial-hybrid" }
                              },
                              [
                                _vm.isDataLoaded
                                  ? _c("div", { staticClass: "legend_title" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title_indicator" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .selectedOffshoreFinancialHybridIndicator
                                                .subtitleLabel
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._m(0),
                                      _vm
                                        .selectedOffshoreFinancialHybridIndicator
                                        .homeUnit != undefined
                                        ? _c(
                                            "div",
                                            { staticClass: "title_unit" },
                                            [
                                              _vm._v(
                                                "(in " +
                                                  _vm._s(
                                                    _vm
                                                      .selectedOffshoreFinancialHybridIndicator
                                                      .homeUnit
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "title_unit" },
                                            [
                                              _vm._v(
                                                "(in " +
                                                  _vm._s(
                                                    _vm
                                                      .selectedOffshoreFinancialHybridIndicator
                                                      .unit
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                    ])
                                  : _vm._e(),
                                _c("highchartsAreaChart", {
                                  attrs: {
                                    areaChartData:
                                      _vm.offshoreFinancialHybridAreaSeries,
                                    areaChartCategories:
                                      _vm.offshoreFinancialHybridAreaCategories,
                                    indicatorUnit:
                                      _vm.offshoreFinancialHybridAreaUnit,
                                    chartID: "AreaChartOffshoreHybrid"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "content_downloadbar" }, [
                              _c(
                                "div",
                                { staticClass: "downloadbar_wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "downloadbar_title" },
                                    [_vm._v("Download")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "downloadbar_bt",
                                      on: {
                                        click: function($event) {
                                          return _vm.exportXLS(
                                            "financial-hybrid"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Dataset (.xslx)")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "downloadbar_bt",
                                      on: {
                                        click: function($event) {
                                          return _vm.exportGraphic(
                                            "financial-hybrid"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Image (.png)")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "downloadbar_bt cite",
                                      on: {
                                        click: function($event) {
                                          return _vm.displayCitationModal(
                                            "offshore-financial"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Cite")]
                                  )
                                ]
                              )
                            ]),
                            _vm.DBDatasetsTexts["offshore-financial"] !=
                            undefined
                              ? _c("div", { staticClass: "content_more" }, [
                                  _c("div", { staticClass: "more_text" }, [
                                    _vm.offshoreFinancialTextExpanded
                                      ? _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.DBDatasetsTexts[
                                                  "offshore-financial"
                                                ].Country_Page_Desc_Tax
                                              )
                                            )
                                          ])
                                        ])
                                      : _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.truncate(
                                                  _vm.DBDatasetsTexts[
                                                    "offshore-financial"
                                                  ].Country_Page_Desc_Tax
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                  ]),
                                  _vm.DBDatasetsTexts["offshore-financial"]
                                    .Country_Page_Desc_Tax.length >
                                  _vm.datasetTextLimit
                                    ? _c(
                                        "div",
                                        { staticClass: "more_actionbar" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "actionbar_bt",
                                              on: {
                                                click: function($event) {
                                                  _vm.offshoreFinancialHybridTextExpanded = !_vm.offshoreFinancialHybridTextExpanded
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.offshoreFinancialHybridTextExpanded
                                                    ? "Collapse"
                                                    : "Read More"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        : _c("div", { staticClass: "section_row" }, [
                            _c("div", { staticClass: "chart_nodatablock" })
                          ])
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "section",
              {
                staticClass: "main_section section_chart",
                attrs: { "data-dataset": "offshore-real-estate" }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm.DBDatasetsTexts["offshore-real-estate"] != undefined
                    ? _c("div", { staticClass: "content_title" }, [
                        _vm._v(
                          "\n                        Offshore real estate wealth in 6 global cities and regions\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm.offshoreEstateHasData
                    ? _c("div", { staticClass: "section_row" }, [
                        _c("div", { staticClass: "row_estate_item" }, [
                          _c("div", { staticClass: "estate_item_wrapper" }, [
                            _vm._m(1),
                            _vm.offshoreEstateTotal != ""
                              ? _c(
                                  "div",
                                  { staticClass: "estate_item_value" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.offshoreEstateTotal.toFixed(2)
                                        ) +
                                        " bn USD\n                                "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _c("div", { staticClass: "row_estate_item" }, [
                          _c("div", { staticClass: "estate_item_wrapper" }, [
                            _c("div", { staticClass: "estate_item_label" }, [
                              _vm._v(
                                "\n                                    Percentage of country's GDP\n                                "
                              )
                            ]),
                            _c("div", { staticClass: "estate_item_value" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.offshoreEstatePctGDP) +
                                  "%\n                                "
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.offshoreEstateHasData
                    ? _c("div", { staticClass: "section_hr" }, [
                        _c("div", { staticClass: "hr_text" }, [
                          _vm._v("Indicator Filters")
                        ])
                      ])
                    : _vm._e(),
                  _vm.offshoreEstateHasData
                    ? _c(
                        "div",
                        {
                          staticClass: "section_row row_filters",
                          attrs: { "data-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Indicator")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.offshoreEstateIndicators,
                                  "return-object": true,
                                  label: "Choose an indicator",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateSelectboxItem(
                                                        data.item.label
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619319307
                                ),
                                model: {
                                  value: _vm.selectedOffshoreEstateIndicator,
                                  callback: function($$v) {
                                    _vm.selectedOffshoreEstateIndicator = $$v
                                  },
                                  expression: "selectedOffshoreEstateIndicator"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.offshoreEstateHasData
                    ? _c("div", { staticClass: "section_row" }, [
                        _vm.isDataLoaded
                          ? _c("div", { staticClass: "legend_title" }, [
                              _vm.selectedOffshoreEstateIndicator.id == "pctGDP"
                                ? _c(
                                    "div",
                                    { staticClass: "title_indicator" },
                                    [
                                      _vm._v(
                                        "Offshore real estate owned as a share of country’s GDP"
                                      )
                                    ]
                                  )
                                : _vm.selectedOffshoreEstateIndicator.id ==
                                  "Aggregate (in USD billions)"
                                ? _c(
                                    "div",
                                    { staticClass: "title_indicator" },
                                    [_vm._v("Total offshore real estate owned")]
                                  )
                                : _vm.selectedOffshoreEstateIndicator.id ==
                                  "pctGlobalEstate"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "title_indicator",
                                      staticStyle: { display: "inline" }
                                    },
                                    [
                                      _vm._v(
                                        "Share of total offshore real estate in city: Offshore real estate owned as a share of the total offshore real estate in the city or area"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "title_unit" }, [
                                _vm._v(
                                  " (in " +
                                    _vm._s(_vm.offshoreEstateIndicatorUnit) +
                                    ")"
                                )
                              ])
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "row_estate_barchart country_wrapper",
                            attrs: { id: "Wrapper_estate" }
                          },
                          [
                            _c("highchartsBarChart", {
                              attrs: {
                                barChartData: _vm.offshoreEstateSeries,
                                barChartCategories:
                                  _vm.offshoreEstateCategories,
                                indicatorUnit: _vm.offshoreEstateIndicatorUnit
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content_downloadbar" }, [
                          _c("div", { staticClass: "downloadbar_wrapper" }, [
                            _c("div", { staticClass: "downloadbar_title" }, [
                              _vm._v("Download")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportXLS("estate")
                                  }
                                }
                              },
                              [_vm._v("Dataset (.xslx)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportGraphic("estate")
                                  }
                                }
                              },
                              [_vm._v("Image (.png)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt cite",
                                on: {
                                  click: function($event) {
                                    return _vm.displayCitationModal(
                                      "offshore-real-estate"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Cite")]
                            )
                          ])
                        ]),
                        _vm.DBDatasetsTexts["offshore-real-estate"] != undefined
                          ? _c("div", { staticClass: "content_more" }, [
                              _c("div", { staticClass: "more_text" }, [
                                _vm.offshoreEstateTextExpanded
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.DBDatasetsTexts[
                                              "offshore-real-estate"
                                            ].Country_Page_Desc_NonTax
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.truncate(
                                            _vm.DBDatasetsTexts[
                                              "offshore-real-estate"
                                            ].Country_Page_Desc_NonTax
                                          )
                                        )
                                      )
                                    ])
                              ]),
                              _vm.DBDatasetsTexts["offshore-real-estate"]
                                .Country_Page_Desc_NonTax.length >
                              _vm.datasetTextLimit
                                ? _c("div", { staticClass: "more_actionbar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "actionbar_bt",
                                        on: {
                                          click: function($event) {
                                            _vm.offshoreEstateTextExpanded = !_vm.offshoreEstateTextExpanded
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.offshoreEstateTextExpanded
                                              ? "Collapse"
                                              : "Read More"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _c("div", { staticClass: "section_row" }, [
                        _c("div", { staticClass: "chart_nodatablock" })
                      ])
                ])
              ]
            ),
            _c(
              "section",
              {
                staticClass: "main_section section_chart",
                attrs: { "data-dataset": "effective-tax" }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm.DBDatasetsTexts["effective-tax"] != undefined
                    ? _c("div", { staticClass: "content_title" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.DBDatasetsTexts["effective-tax"].title) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm.effectiveTaxHasData
                    ? _c("div", { staticClass: "section_row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "country_wrapper",
                            attrs: { id: "Wrapper_effective" }
                          },
                          [
                            _c("highchartsTimeSeries", {
                              attrs: {
                                timeSeriesData: _vm.effectiveTaxSeries,
                                timeSeriesCategories:
                                  _vm.effectiveTaxCategories,
                                indicatorUnit: "%"
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content_downloadbar" }, [
                          _c("div", { staticClass: "downloadbar_wrapper" }, [
                            _c("div", { staticClass: "downloadbar_title" }, [
                              _vm._v("Download")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportXLS("effective")
                                  }
                                }
                              },
                              [_vm._v("Dataset (.xslx)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportGraphic("effective")
                                  }
                                }
                              },
                              [_vm._v("Image (.png)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt cite",
                                on: {
                                  click: function($event) {
                                    return _vm.displayCitationModal(
                                      "effective-tax"
                                    )
                                  }
                                }
                              },
                              [_vm._v("Cite")]
                            )
                          ])
                        ]),
                        _vm.DBDatasetsTexts["effective-tax"] != undefined
                          ? _c("div", { staticClass: "content_more" }, [
                              _c("div", { staticClass: "more_text" }, [
                                _vm.effectiveTaxTextExpanded
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.DBDatasetsTexts["effective-tax"]
                                              .Country_Page_Desc_NonTax
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.truncate(
                                            _vm.DBDatasetsTexts["effective-tax"]
                                              .Country_Page_Desc_NonTax
                                          )
                                        )
                                      )
                                    ])
                              ]),
                              _vm.DBDatasetsTexts["effective-tax"]
                                .Country_Page_Desc_NonTax.length >
                              _vm.datasetTextLimit
                                ? _c("div", { staticClass: "more_actionbar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "actionbar_bt",
                                        on: {
                                          click: function($event) {
                                            _vm.effectiveTaxTextExpanded = !_vm.effectiveTaxTextExpanded
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.effectiveTaxTextExpanded
                                              ? "Collapse"
                                              : "Read More"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _c("div", { staticClass: "section_row" }, [
                        _c("div", { staticClass: "chart_nodatablock" })
                      ])
                ])
              ]
            )
          ]
        )
      ]),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title_taxhavens", attrs: { "data-taxhavens": "true" } },
      [_c("span", [_vm._v("held")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "estate_item_label" }, [
      _vm._v("\n                                    Total offshore"),
      _c("br"),
      _vm._v("real estate wealth \n                                ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74baf884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74baf884","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/country/_countryID.vue
// module id = RzIv
// module chunks = 2